import React, { ReactNode, useContext, useMemo, useState } from 'react';

export interface IAccountProps {
  name: string;
  number?: string;
}

export const setAccountInStorage = (payload: IAccountProps) => {
  localStorage.setItem('guidance_account', JSON.stringify(payload));
};

export const getAccountFromStorage = () => {
  const account = localStorage.getItem('guidance_account');

  if (account) {
    return JSON.parse(account) as IAccountProps;
  }

  return undefined;
};

interface AccountProviderProps {
  account: IAccountProps | undefined;
  handeUpdateAccount: (payload: IAccountProps) => void;
}

const defaultValue: AccountProviderProps = {
  account: undefined,
  handeUpdateAccount: () => undefined,
};

const AccountContext = React.createContext<AccountProviderProps>(defaultValue);

function AccountContextProvider({ children }: { children: ReactNode }) {
  const [account, setAccount] = useState<IAccountProps>();

  const handeUpdateAccount = (newAccount: IAccountProps) => {
    setAccount(newAccount);
  };

  const memoizedValue: AccountProviderProps = useMemo(
    () => ({
      account,
      handeUpdateAccount,
    }),
    [account],
  );

  return <AccountContext.Provider value={memoizedValue}>{children}</AccountContext.Provider>;
}

export default AccountContextProvider;
export const useAccountContextProvider = (): AccountProviderProps => useContext(AccountContext);
